<template>
  <div class="mobile-home-wrap">
    <Header />
    <Swiper />
    <Advantage />
    <Example />
    <Bottom />
  </div>
</template>

<script>
import Header from '@/views/mobile/components/Header'
import Index from '@/views/home'
import Swiper from '@/views/mobile/components/Swiper'
import Advantage from '@/views/mobile/components/Advantage'
import Example from '@/views/mobile/components/Example'
import Bottom from '@/views/mobile/components/Bottom'
export default {
  name: "MobileHome",
  components: {
    Index,
    Header,
    Swiper,
    Advantage,
    Example,
    Bottom
  },
  data() {
    return {
      images: [
        {
          id: '1',
          url: require('@/assets/images/mobile/swipe1.png'),
        },
        {
          id: '2',
          url: require('@/assets/images/mobile/swipe2.png'),
        },
        {
          id: '3',
          url: require('@/assets/images/mobile/swipe3.png'),
        }
      ],
    }
  }
}
</script>

<style lang="less" scoped>
.mobile-home-wrap {
  overflow-y: auto;
  overflow-x: hidden;
  width: calc(100vw);
  height: 100vh;
  height: calc(100vh - constant(safe-area-inset-top)- constant(safe-area-inset-bottom));
  height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

}

</style>
